/*
    🔥 POSICIÓN — UNA SOLA VERDAD, SEIS TRADUCCIONES

    Cada librería nombra las posiciones distinto. Acá se define una vez
    y se traduce a cada una. Cambiar de librería no mueve el toast.
*/

export const TOAST_POSITIONS = [
    { id: 'top-left', label: 'Arriba izquierda' },
    { id: 'top-center', label: 'Arriba centro' },
    { id: 'top-right', label: 'Arriba derecha' },
    { id: 'bottom-left', label: 'Abajo izquierda' },
    { id: 'bottom-center', label: 'Abajo centro' },
    { id: 'bottom-right', label: 'Abajo derecha' },
];

export const TOAST_POSITION_IDS = TOAST_POSITIONS.map((item) => item.id);

const FALLBACK = 'top-right';

export const onSafePosition = (id) => (TOAST_POSITION_IDS.includes(id) ? id : FALLBACK);

// sonner, react-hot-toast y toastify usan estos mismos nombres
export const onPositionNative = (id) => onSafePosition(id);

// notistack usa un objeto
export const onPositionNotistack = (id) => {
    const [vertical, horizontal] = onSafePosition(id).split('-');
    return { vertical, horizontal: horizontal === 'center' ? 'center' : horizontal };
};

// sweetalert2 usa start/end
const SWAL_MAP = {
    'top-left': 'top-start', 'top-center': 'top', 'top-right': 'top-end',
    'bottom-left': 'bottom-start', 'bottom-center': 'bottom', 'bottom-right': 'bottom-end',
};

export const onPositionSwal = (id) => SWAL_MAP[onSafePosition(id)] ?? 'top-end';
